import React from 'react';
import { useTranslation } from 'react-i18next';
import NoData from '../../components/NoData';
import { HostProvider } from '../../utils/HostProvider';

const NoVales = () => {
  const { t } = useTranslation();
  const isCaprabo = HostProvider.isCaprabo();

  return (
    <NoData>
      <div className="mensaje">
        <p>
          {isCaprabo
            ? t('ahorros.no-records-caprabo')
            : t('ahorros.no-records')}
        </p>
      </div>
    </NoData>
  );
};

export default NoVales;
